import React, { useState } from 'react';
import { Button } from '../ui/button';
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel } from '../ui/alert-dialog';

// Pure design preview. Does not start OAuth, request tokens or authenticate users.
export const GooglePreview = ({ onContinue }) => {
  const [open, setOpen] = useState(false);
  return <>
    <Button type="button" className="sr-secondary" onClick={() => setOpen(true)} data-testid="signup-review-google-button">
      <img src="/assets/brand/google-g.png" width="18" height="18" alt="" aria-hidden="true" data-testid="signup-review-google-logo" />Sign up with Google
    </Button>
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent className="sr-google-dialog" data-testid="signup-review-google-dialog">
        <AlertDialogTitle data-testid="signup-review-google-title">Google signup preview</AlertDialogTitle>
        <AlertDialogDescription className="sr-google-description" data-testid="signup-review-google-disclaimer">MOCKED — Google is not connected to this preview. Continue with a sample profile to see the next steps. No account will be created.</AlertDialogDescription>
        <div className="sr-google-actions">
          <AlertDialogCancel data-testid="signup-review-google-cancel">Back</AlertDialogCancel>
          <AlertDialogAction onClick={onContinue} data-testid="signup-review-google-sample-continue">Use sample profile</AlertDialogAction>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  </>;
};